import * as React from 'react';
import { MenuItem } from '@chakra-ui/react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompressAlt, faArrowsLeftRight } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

const MergeMenuItem = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().mergeCells().run()}
         icon={<FontAwesomeIcon icon={faCompressAlt} transform={{ rotate: 45 }} size="lg" />}
         title={_js('Merge Cells')}
         iconSpacing={0}
      />
   );
};
const SplitMenuItem = () => {
   const { editor } = useEditorContext();
   const { _js } = useLocalization();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().splitCell().run()}
         icon={<FontAwesomeIcon icon={faArrowsLeftRight} size="lg" />}
         isDisabled={!editor.can().splitCell()}
         title={_js('Split Cell')}
         iconSpacing={0}
      />
   );
};

export const MergeOrSplitMenuItem = () => {
   const { editor } = useEditorContext();

   return editor.can().mergeCells() ? <MergeMenuItem /> : <SplitMenuItem />;
};
